(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["musteri-yorum"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if(root.dataset.reviewVersion==='12')return;
  root.veiraReviewsCleanup?.();
  root.dataset.connected='true';root.dataset.reviewVersion='12';
  const track=root.querySelector('.my-track'),prev=root.querySelector('[data-review-prev]'),next=root.querySelector('[data-review-next]');
  const loadButton=root.querySelector('[data-review-load]'),status=root.querySelector('.my-auto-status');
  const controller=new AbortController(),signal=controller.signal;
  const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
  const token=root.dataset.publicToken.trim(),automatic=root.dataset.auto==='true'&&!!token;
  const manualFirst=root.dataset.manualFirst!=='false',batch=Number(root.dataset.batch)||20;
  const hideRatingOnly=root.dataset.hideRatingOnly==='true';
  const streams=[{type:'product-reviews',page:1,done:false,previous:''}];
  if(root.dataset.storeReviews==='true')streams.push({type:'shop-reviews',page:1,done:false,previous:''});
  let streamIndex=0,busy=false,failed=false,frame=0,loaded=0,publishedCount=null;
  const autoCount=root.dataset.autoCount==='true',countSource=root.dataset.countSource||'published';
  const ids=new Set(),signatures=new Set(),fallbackSignatures=new Set(),productCache=new Map();
  const normal=t=>String(t||'').normalize('NFKC').replace(/\s+/g,' ').trim().toLocaleLowerCase('tr-TR');
  const signature=(name,body)=>normal(name)+'|'+normal(body);
  track.querySelectorAll('[data-manual-review]').forEach(card=>{
   signatures.add(signature(card.querySelector('.my-name')?.textContent,card.querySelector('.my-text')?.textContent));
  });
  function prioritizeCustomerMedia(preservePosition=false){
   const mediaFirst=root.dataset.mediaFirst==='true',ratingLast=root.dataset.ratingOnlyLast==='true';
   if(!mediaFirst&&!ratingLast)return;
   const cards=Array.from(track.querySelectorAll('.my-card'));
   const trackRect=track.getBoundingClientRect();
   const visible=preservePosition?cards.find(card=>{const rect=card.getBoundingClientRect();return rect.right>trackRect.left+1&&rect.left<trackRect.right-1;}):null;
   const previousLeft=visible?.getBoundingClientRect().left;
   const priority=card=>(ratingLast&&card.dataset.ratingOnly==='true'?4:0)+(mediaFirst&&card.dataset.customerMedia!=='true'?2:0)+(card.hasAttribute('data-manual-review')===manualFirst?0:1);
   const ordered=cards.slice().sort((a,b)=>priority(a)-priority(b));
   if(ordered.every((card,index)=>card===cards[index]))return;
   ordered.forEach((card,index)=>{if(track.children[index]!==card)track.insertBefore(card,track.children[index]||null);});
   if(visible){
    const delta=visible.getBoundingClientRect().left-previousLeft;
    if(delta){const behavior=track.style.scrollBehavior;track.style.scrollBehavior='auto';track.scrollLeft+=delta;track.style.scrollBehavior=behavior;}
   }
  }
  prioritizeCustomerMedia();
  function update(){
   frame=0;const max=track.scrollWidth-track.clientWidth,position=Math.abs(track.scrollLeft);
   prev.disabled=position<=2;next.disabled=position>=max-2;
   track.querySelectorAll('.my-card').forEach(card=>{
    const text=card.querySelector('.my-text');if(!text)return;
    text.style.setProperty('max-height','none','important');
    let button=card.querySelector('[data-more]');if(button)button.hidden=true;
    const clipped=text.scrollHeight>text.clientHeight+1;
    if(!button&&clipped){button=make('button','my-more','Devamını oku');button.type='button';button.dataset.more='';text.insertAdjacentElement('afterend',button);}
    if(button){button.hidden=!clipped;button.textContent='Devamını oku';button.setAttribute('aria-haspopup','dialog');button.removeAttribute('aria-expanded');}
    if(clipped){
     const style=getComputedStyle(text),lineHeight=parseFloat(style.lineHeight)||parseFloat(style.fontSize)*1.5;
     const lines=Math.max(0,Math.floor((text.clientHeight+.1)/lineHeight));
     text.style.setProperty('max-height',`${Math.floor(lines*lineHeight)}px`,'important');
    }
   });
   if(autoCount){
    const count=countSource==='loaded'||!automatic?track.querySelectorAll('.my-card').length:publishedCount;
    const label=root.querySelector('.my-total-text');label.hidden=count===null;
    if(count!==null)label.textContent=new Intl.NumberFormat('tr-TR').format(count)+' değerlendirme';
   }
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  function move(direction){
   const card=track.querySelector('.my-card');if(!card)return;
   const gap=parseFloat(getComputedStyle(track).columnGap)||0;
   track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap)*(getComputedStyle(track).direction==='rtl'?-1:1),behavior:reduced.matches?'auto':'smooth'});
  }
  prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>{move(1);if(automatic&&Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth*1.6)load();},{signal});
  const fullDialog=root.querySelector('.my-review-dialog');
  root.addEventListener('click',e=>{
   if(e.target.closest('[data-full-close]')){fullDialog.close();return;}
   const btn=e.target.closest('[data-more]');if(!btn)return;
   const card=btn.closest('.my-card');
   const author=card.querySelector('.my-name')?.textContent.trim()||'Müşteri yorumu';
   const title=card.querySelector('.my-card-title')?.textContent.trim()||'';
   fullDialog.querySelector('.my-full-heading').textContent=author;
   const stars=make('span','my-full-stars',card.querySelector('.my-stars')?.textContent.trim()||'');
   const date=make('span','my-full-date',card.querySelector('.my-date')?.textContent.trim()||'');
   fullDialog.querySelector('.my-full-meta').replaceChildren(stars,date);
   const titleNode=fullDialog.querySelector('.my-full-review-title');
   titleNode.textContent=title;titleNode.hidden=!title||normal(title)===normal(author);
   fullDialog.dataset.openedWithPointer=String(e.detail>0);
   fullDialog.querySelector('.my-full-text').textContent=card.querySelector('.my-text')?.innerText||'';
   delete fullDialog.dataset.keyboardNavigation;fullDialog.showModal();
   fullDialog.querySelector('.my-full-heading').focus({preventScroll:true});
  },{signal});
  fullDialog.addEventListener('keydown',e=>{if(e.key==='Tab'){delete fullDialog.dataset.openedWithPointer;fullDialog.dataset.keyboardNavigation='true';}},{signal});
  fullDialog.addEventListener('click',e=>{if(e.target!==fullDialog)return;const rect=fullDialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)fullDialog.close();},{signal});
  track.addEventListener('scroll',()=>{
   schedule();const max=track.scrollWidth-track.clientWidth;
   if(automatic&&!failed&&Math.abs(track.scrollLeft)>20&&Math.abs(track.scrollLeft)>=max-track.clientWidth*.6)load();
  },{passive:true,signal});
  const resize=new ResizeObserver(schedule);resize.observe(track);
  function make(tag,cls,text){const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el;}
  function safeURL(value){if(typeof value!=='string'||!value.trim())return '';try{const url=new URL(value.trim(),location.origin);return url.protocol==='https:'?url.href:'';}catch{return '';}}
  function productURL(value){try{const url=new URL(value,location.origin);return url.origin===location.origin&&/\/products\/[^/]+/.test(url.pathname)?url.href:'';}catch{return '';}}
  function dateText(raw){
   const match=String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/);if(!match)return raw;
   const dt=new Date(Date.UTC(+match[1],+match[2]-1,+match[3],12));
   return new Intl.DateTimeFormat('tr-TR',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(dt);
  }
  function customerImageURL(picture){
   if(!picture)return '';
   const candidates=[];
   const add=value=>{const url=safeURL(value);if(url)candidates.push(url);};
   for(const attr of ['data-original-src','data-original-url','data-original','data-full-src','data-full-url'])add(picture.getAttribute(attr));
   const anchor=picture.closest('a');
   const href=safeURL(anchor?.getAttribute('href')||'');
   if(href){const url=new URL(href);if(url.hostname==='review-images.judgeme.com'||/\.(?:jpe?g|png|webp|avif)(?:$)/i.test(url.pathname))add(href);}
   const srcset=picture.getAttribute('data-srcset')||picture.getAttribute('srcset')||'';
   srcset.split(',').map(part=>part.trim().split(/\s+/)).filter(parts=>parts[0]).sort((a,b)=>(parseFloat(b[1])||1)-(parseFloat(a[1])||1)).forEach(parts=>add(parts[0]));
   add(picture.getAttribute('data-src'));add(picture.getAttribute('src'));
   const selected=candidates.find(value=>new URL(value).pathname.includes('__original.'))||candidates[0];
   if(!selected)return '';
   const url=new URL(selected);
   if(url.hostname==='review-images.judgeme.com'){
    url.searchParams.set('width','1024');url.searchParams.set('quality','90');
    return url.href;
   }
   return selected;
  }
  function extract(node){
   const text=selector=>node.querySelector(selector)?.textContent.trim()||'';
   const ratingNode=node.querySelector('.jdgm-rev__rating,.jm-star-rating');
   const rawRating=ratingNode?.getAttribute('data-score')||ratingNode?.getAttribute('data-rating');
   const label=ratingNode?.getAttribute('aria-label')||'';
   const fromLabel=label.match(/[0-5](?:[.,]\d+)?/);
   const score=rawRating!==null&&rawRating!==undefined?Number(rawRating):fromLabel?Number(fromLabel[0].replace(',','.')):ratingNode?.querySelectorAll('.jdgm--on').length;
   const link=node.querySelector('.jdgm-rev__prod-link,a[href*="/products/"]');
   const href=productURL(link?.getAttribute('href')||'');
   const picture=node.querySelector('.jdgm-rev__pic-img,.jm-review-media img');
   const productImage=link?.querySelector('img');
   const imgURL=img=>safeURL(img?.getAttribute('data-src')||img?.getAttribute('src')||'');
   const timestamp=node.querySelector('.jdgm-rev__timestamp,time,.jm-reviewer-info__details time');
   const badge=node.querySelector('.jdgm-rev__buyer-badge,.jm-verified-buyer-badge');
   return {id:node.getAttribute('data-review-id')||node.id||'',name:text('.jdgm-rev__author,.jm-reviewer-info__name')||'Anonim',body:text('.jdgm-rev__body,.jm-review-content__body'),title:text('.jdgm-rev__title,.jm-review-content__title'),rating:Number.isFinite(score)?Math.max(0,Math.min(5,score)):null,date:dateText(timestamp?.getAttribute('data-content')||timestamp?.getAttribute('datetime')||timestamp?.textContent.trim()||''),verified:node.getAttribute('data-verified-buyer')==='true'||(!!badge&&!!badge.textContent.trim()&&!badge.hidden&&!/display\s*:\s*none/i.test(badge.getAttribute('style')||'')),productURL:href,productTitle:link?.getAttribute('title')||link?.textContent.trim()||productImage?.getAttribute('alt')||'',productImage:imgURL(productImage),reviewImage:customerImageURL(picture),reviewImageFallback:imgURL(picture)};
  }
  function cachedProduct(href){
   try{const stored=JSON.parse(sessionStorage.getItem('veira-review-product:'+href)||'null');
    return stored&&Date.now()-stored.at<15*60*1000?stored.product:null;
   }catch{return null;}
  }
  function applyProduct(data,product){
   if(!product)return;
   data.productTitle=product.title||data.productTitle;
   data.productImage=safeURL(typeof product.featured_image==='string'?product.featured_image:product.featured_image?.src||product.images?.[0]||'');
  }
  function showMedia(card,data){
   if(signal.aborted)return;
   const image=root.dataset.autoMedia==='review'?(data.reviewImage||data.productImage):(data.productImage||data.reviewImage);
   if(!image)return;
   let media=card.querySelector('.my-media');
   if(media?.dataset.source===image){
    const name=media.querySelector('.my-pname');if(name)name.textContent=data.productTitle;
    return;
   }
   if(media){
    const preload=new Image();
    preload.onload=()=>{if(signal.aborted||!media.isConnected)return;const img=media.querySelector('img');img.src=image;img.alt=data.productTitle||img.alt;media.dataset.source=image;const name=media.querySelector('.my-pname');if(name)name.textContent=data.productTitle;};
    preload.src=image;return;
   }
   media=make('div','my-media');media.dataset.source=image;
   const link=make(data.productURL?'a':'div','my-link');
   if(data.productURL){link.href=data.productURL;link.setAttribute('aria-label',data.productTitle||'Ürüne git');}
   const img=make('img');img.loading=Number(card.dataset.reviewIndex)<4?'eager':'lazy';img.decoding='async';
   img.width=300;img.height=360;img.alt=data.productTitle||'Müşterinin paylaştığı görsel';
   const fallbacks=[...(root.dataset.autoMedia==='review'?[data.reviewImageFallback,data.productImage]:[data.reviewImage,data.reviewImageFallback])].filter((value,index,all)=>value&&value!==image&&all.indexOf(value)===index);
   img.addEventListener('error',()=>{
    const fallback=fallbacks.shift();
    if(fallback){img.src=fallback;media.dataset.source=fallback;}
    else media.remove();
   },{signal});
   link.append(img);
   if(data.productURL){const go=make('span','my-go');go.append(make('span','my-pname',data.productTitle),make('span','my-cta','Ürüne Git →'));link.append(go);}
   media.append(link);card.append(media);img.src=image;
  }
  async function enrich(card,data){
   if(!data.productURL)return;
   if(data.productImage){showMedia(card,data);return;}
   const url=new URL(data.productURL);url.search='';url.hash='';url.pathname=(url.pathname.endsWith('/')?url.pathname.slice(0,-1):url.pathname)+'.js';
   const cached=cachedProduct(url.href);
   if(cached){applyProduct(data,cached);showMedia(card,data);return;}
   if(!productCache.has(url.href))productCache.set(url.href,fetch(url,{credentials:'same-origin',signal}).then(r=>{if(!r.ok)throw Error('product');return r.json();}).then(product=>{
    const compact={title:product.title,featured_image:typeof product.featured_image==='string'?product.featured_image:product.featured_image?.src||product.images?.[0]||''};
    try{sessionStorage.setItem('veira-review-product:'+url.href,JSON.stringify({at:Date.now(),product:compact}));}catch{}
    return compact;
   }).catch(()=>null));
   const product=await productCache.get(url.href);if(!product||signal.aborted)return;
   applyProduct(data,product);showMedia(card,data);
  }
  function startEnrichment(items){
   let index=0;
   async function worker(){while(index<items.length&&!signal.aborted){const [card,data]=items[index++];await enrich(card,data);}}
   for(let i=0;i<Math.min(6,items.length);i++)worker().catch(()=>{});
  }
  function render(data,customerMedia=false){
   const card=make('article','my-card');card.dataset.judgemeReview=data.id;card.dataset.reviewIndex=String(loaded);
   if(data.productURL){const url=new URL(data.productURL);url.search='';url.hash='';url.pathname=url.pathname.replace(/\/$/,'')+'.js';applyProduct(data,cachedProduct(url.href));}
   const top=make('div','my-top'),meta=make('div','my-meta'),identity=make('div','my-identity');identity.append(make('span','my-name',data.name));
   if(data.rating!==null){const stars=make('span','my-stars');stars.setAttribute('aria-label',`${data.rating} / 5 yıldız`);stars.textContent='★'.repeat(Math.round(data.rating))+'☆'.repeat(5-Math.round(data.rating));identity.append(stars);}
   meta.append(identity,make('span','my-date',data.date));top.append(meta);if(data.title)top.append(make('h3','my-card-title',data.title));
   if(data.body)top.append(make('p','my-text',data.body));
   if(!data.body.trim()&&!data.title.trim()&&!customerMedia&&root.dataset.emptyReviewText?.trim())top.append(make('p','my-empty-review',root.dataset.emptyReviewText));
   if(data.body.length>90){const btn=make('button','my-more','Devamını oku');btn.type='button';btn.dataset.more='';btn.setAttribute('aria-expanded','false');top.append(btn);}
   if(data.verified)top.append(make('div','my-verified','Satın Alınmış'));
   card.append(top);showMedia(card,data);return card;
  }
  function htmlFrom(payload){
   if(typeof payload==='string')return payload;
   for(const key of ['all_reviews','widget','html','reviews_tab','all_reviews_page'])if(typeof payload?.[key]==='string')return payload[key];
   throw Error('format');
  }
  async function load(){
   if(busy||!automatic||streamIndex>=streams.length||signal.aborted)return;
   const countBefore=loaded;let advanceEmptyPage=false;
   busy=true;failed=false;loadButton.hidden=false;loadButton.disabled=true;status.textContent='Yorumlar yükleniyor…';
   try{
    const current=streams[streamIndex];
    const url=new URL('https://api.judge.me/api/v1/widgets/all_reviews_page');
    url.search=new URLSearchParams({shop_domain:root.dataset.shop,api_token:token,page:String(current.page),per_page:String(batch),review_type:current.type});
    const response=await fetch(url,{credentials:'omit',signal,referrerPolicy:'no-referrer'});if(!response.ok)throw Error('http-'+response.status);
    const raw=await response.text();let payload;try{payload=JSON.parse(raw);}catch{payload=raw;}
    if(typeof payload?.all_reviews_header==='string'){
     const headerDoc=new DOMParser().parseFromString(payload.all_reviews_header,'text/html');
     const header=headerDoc.querySelector('[data-number-of-reviews]');
     const attribute=root.dataset.storeReviews==='true'?'data-number-of-reviews':'data-number-of-product-reviews';
     const raw=header?.getAttribute(attribute);
     if(raw!==null&&raw!==undefined&&raw.trim()!==''&&Number.isFinite(Number(raw)))publishedCount=Number(raw);
    }
    const html=htmlFrom(payload);const doc=new DOMParser().parseFromString(html,'text/html');
    const nodes=Array.from(doc.querySelectorAll('.jdgm-rev,.jm-review-item'));
    if(html.trim()&&!nodes.length&&!doc.querySelector('.jdgm-rev-widg,.jdgm-revs-tab,.jdgm-all-reviews-widget,.jdgm-paginate,.jm-review-widget')&&!/no reviews|no-review|0 reviews|henüz|yorum yok/i.test(html))throw Error('format');
    const fingerprint=nodes.map(n=>n.getAttribute('data-review-id')||n.textContent.trim()).join('|');
    const repeated=!!fingerprint&&fingerprint===current.previous;current.previous=fingerprint;
    const anchor=manualFirst?null:track.querySelector('[data-manual-review]');
    const fragment=document.createDocumentFragment(),enrichment=[];
    if(!repeated)for(const node of nodes){
     const data=extract(node),key=signature(data.name,data.body||data.title);
     const customerMedia=!!data.reviewImage||!!node.querySelector('.jdgm-rev__vids video,.jdgm-rev__vids iframe,.jdgm-rev__vids a,.jdgm-rev__vids [data-video-url],.jm-review-media video,.jm-review-media iframe');
     if(hideRatingOnly&&!data.body.trim()&&!data.title.trim()&&!customerMedia)continue;
     if((data.id&&ids.has(data.id))||signatures.has(key)||(!data.id&&fallbackSignatures.has(key)))continue;
     if(data.id)ids.add(data.id);else fallbackSignatures.add(key);const card=render(data,customerMedia);card.dataset.customerMedia=String(customerMedia);card.dataset.ratingOnly=String(!data.body.trim()&&!data.title.trim()&&!customerMedia);fragment.append(card);enrichment.push([card,data]);loaded++;
    }
    const preservePosition=Math.abs(track.scrollLeft)>2;
    track.insertBefore(fragment,anchor);
    prioritizeCustomerMedia(preservePosition);
    startEnrichment(enrichment);
    current.page++;
    if(repeated||!nodes.length){current.done=true;streamIndex++;}
    advanceEmptyPage=hideRatingOnly&&loaded===countBefore&&streamIndex<streams.length;
    status.textContent='';
    loadButton.textContent='Daha fazla yorum yükle';loadButton.hidden=streamIndex>=streams.length;
    schedule();
   }catch(error){if(signal.aborted)return;failed=true;status.textContent=error.message==='http-401'||error.message==='http-403'?'Judge.me bağlantıyı reddetti. Public API Token alanını kontrol et.':error.message==='format'?'Judge.me yanıtı okunamadı. Tekrar deneyebilirsin.':'Yorumlar şu an yüklenemedi. Tekrar deneyebilirsin.';loadButton.hidden=false;loadButton.textContent='Tekrar dene';}
   finally{busy=false;loadButton.disabled=false;if(advanceEmptyPage&&!failed&&!signal.aborted)requestAnimationFrame(load);}
  }
  loadButton.addEventListener('click',load,{signal});
  let visibility;
  if(automatic){visibility=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){visibility.disconnect();load();}},{rootMargin:'900px'});visibility.observe(root);}
  else root.querySelector('.my-auto-footer').hidden=true;
  root.veiraReviewsCleanup=()=>{if(fullDialog.open)fullDialog.close();controller.abort();resize.disconnect();visibility?.disconnect();if(frame)cancelAnimationFrame(frame);};
  update();document.fonts?.ready.then(()=>{if(!signal.aborted)schedule();});
 };
 const scan=scope=>scope.querySelectorAll('[data-veira-customer-reviews]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 if(!window.veiraCustomerReviewsLifecycle12){
  window.veiraCustomerReviewsLifecycle12=true;
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-veira-customer-reviews]').forEach(root=>root.veiraReviewsCleanup?.()));
 }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-code"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('veira-partner-guide')){
 customElements.define('veira-partner-guide',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
   const input=this.querySelector('[data-vpg-amount]'),output=this.querySelector('[data-vpg-result]');
   if(input&&output){
    let formatter;try{formatter=new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.dataset.currency||'TRY'});}catch{formatter=new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'});}
    const update=()=>{const amount=input.valueAsNumber,rate=Number(this.dataset.rate);if(!Number.isFinite(amount)||amount<0){output.textContent='—';return;}const earnedCents=Math.round(Math.round(amount*100)*rate/100);output.textContent=formatter.format(earnedCents/100);};
    input.addEventListener('input',update,{signal});update();
   }
   if(this.dataset.editor==='true')this.addEventListener('shopify:block:select',event=>{const details=event.target.closest('details.vpg__question');if(details)details.open=true;},{signal});
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veira-forms"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('veira-forms-popup-v11')){
 customElements.define('veira-forms-popup-v11',class extends HTMLElement{
  connectedCallback(){
   this.formStyleObserver?.disconnect();this.formShadowObserver?.disconnect();clearTimeout(this.formStyleTimer);this.controller?.abort();clearTimeout(this.timer);clearTimeout(this.loadTimer);this.resize?.disconnect();this.mutation?.disconnect();
   this.controller=new AbortController();const signal=this.controller.signal;
   this.dialog=this.querySelector('dialog');this.previousFocus=null;this.editor=this.dataset.editor==='true';this.attempts=0;
   this.photoResize?.disconnect();
   const visual=this.querySelector('.vfp-visual');
   if(visual){
    const fitPhoto=()=>{const width=visual.getBoundingClientRect().width;const ratio=Number(this.dataset.imageRatio)||1;if(width>0)this.style.setProperty('--vfp-photo-height',Math.min(width/ratio,Math.max(1,window.innerHeight-48))+'px');};
    this.photoResize=new ResizeObserver(fitPhoto);this.photoResize.observe(visual);fitPhoto();
   }
   const media=matchMedia('(max-width:749px)');
   const allowed=()=>{const device=this.dataset.devices||'all';const page=this.dataset.pages||'all';return(device==='all'||device==='mobile'&&media.matches||device==='desktop'&&!media.matches)&&(page==='all'||page===this.dataset.pageType);};
   const availability=()=>{this.dataset.deviceHidden=String(!allowed());if(!allowed()&&this.dialog.open&&!this.editor)this.close();this.syncTeaser?.();};availability();media.addEventListener('change',availability,{signal});
   const remember=()=>{if(this.editor)return;const key=this.dataset.storageKey;try{if(this.dataset.frequency==='session')sessionStorage.setItem(key,'1');else if(this.dataset.frequency==='days')localStorage.setItem(key,String(Date.now()));}catch{}};
   const seen=()=>{try{if(this.dataset.frequency==='session')return sessionStorage.getItem(this.dataset.storageKey)==='1';if(this.dataset.frequency==='days'){const time=Number(localStorage.getItem(this.dataset.storageKey));return time>0&&Date.now()-time<Number(this.dataset.days)*86400000;}}catch{}return false;};
   this.syncTeaser=()=>{
    const teaser=this.querySelector('[data-vfp-open]');if(!teaser)return;
    const usable=this.editor||(this.dataset.enabled==='true'&&this.dataset.configured==='true'&&allowed());
    const waitingForAuto=this.dataset.auto==='true'&&!seen()&&!this.hasOpened;
    teaser.hidden=!usable||(!this.editor&&waitingForAuto);
   };
   this.syncTeaser();

   this.open=()=>{if(!this.editor&&(this.dataset.enabled!=='true'||this.dataset.configured!=='true'||!allowed()))return;if(this.dialog.open)return;this.previousFocus=document.activeElement;this.dialog.dataset.keyboard='false';this.dialog.showModal();this.hasOpened=true;this.syncTeaser();this.dialog.focus({preventScroll:true});this.checkForm?.();clearTimeout(this.loadTimer);if(this.dataset.editorMock!=='true')this.loadTimer=setTimeout(()=>{const mount=this.querySelector('.vfp-form-mount');if(!mount||mount.dataset.vfpState==='ready')return;const loading=this.querySelector('.vfp-loading');if(loading){loading.textContent=this.editor?'Form bağlanamadı. Satır içi form kimliğini ve Forms uygulama yerleştirmesini kontrol edin.':'Form şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.';}const help=this.querySelector('.vfp-connect-help');if(help)help.hidden=false;},12000);remember();};
   this.close=()=>{clearTimeout(this.loadTimer);if(!this.dialog.open)return;this.dialog.close();if(this.previousFocus?.isConnected)this.previousFocus.focus({preventScroll:true});};
   this.addEventListener('click',event=>{if(event.target.closest('[data-vfp-open]'))this.open();if(event.target.closest('[data-vfp-close]'))this.close();},{signal});
   this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();},{signal});
   this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal});
   this.dialog.addEventListener('pointerdown',()=>this.dialog.dataset.keyboard='false',{capture:true,signal});
   this.dialog.addEventListener('keydown',event=>{if(event.key==='Tab')this.dialog.dataset.keyboard='true';},{signal});

   // Style the existing official fields without cloning, replacing or intercepting submission.
   const styleTemplate=this.querySelector('[data-vfp-form-style]');
   const styleForm=()=>{
    for(const embed of this.querySelectorAll('.vfp-form-mount shopify-forms-embed')){
     const root=embed.shadowRoot;if(!root||!styleTemplate)continue;
     if(!root.querySelector('style[data-veira-form-style]'))root.append(styleTemplate.content.cloneNode(true));
     if(this.styledFormRoot!==root){
      this.formShadowObserver?.disconnect();this.styledFormRoot=root;
      this.formShadowObserver=new MutationObserver(()=>{if(!root.querySelector('style[data-veira-form-style]'))styleForm();});
      this.formShadowObserver.observe(root,{childList:true});
     }
    }
   };
   const formMount=this.querySelector('.vfp-form-mount');
   if(formMount){this.formStyleObserver=new MutationObserver(styleForm);this.formStyleObserver.observe(formMount,{childList:true,subtree:true});}
   let styleAttempts=0;
   const waitForForm=()=>{if(!this.isConnected)return;styleForm();if(!this.styledFormRoot&&styleAttempts++<120)this.formStyleTimer=setTimeout(waitForForm,500);};
   if(formMount)waitForForm();

   const mount=this.querySelector('.vfp-form-mount'),loading=this.querySelector('.vfp-loading');
   if(mount&&loading){const check=()=>{if(mount.getBoundingClientRect().height>40){loading.hidden=true;mount.dataset.vfpState='ready';clearTimeout(this.loadTimer);const help=this.querySelector('.vfp-connect-help');if(help)help.hidden=true;}};this.checkForm=check;this.resize=new ResizeObserver(check);this.resize.observe(mount);this.mutation=new MutationObserver(check);this.mutation.observe(mount,{childList:true,subtree:true});check();}
   window.addEventListener('storage',()=>this.syncTeaser(),{signal});
   const auto=()=>{this.syncTeaser();if(!this.isConnected||this.dialog.open||seen()||!allowed()||document.hidden)return;if(document.querySelector('dialog[open]')){if(this.attempts++<10)this.timer=setTimeout(auto,3000);return;}this.open();};
   if(!this.editor&&this.dataset.enabled==='true'&&this.dataset.configured==='true'&&this.dataset.auto==='true')this.timer=setTimeout(auto,Number(this.dataset.delay)*1000);
   if(this.editor&&this.dataset.editorPreview==='true')this.open();
   this.addEventListener('shopify:block:select',()=>{if(this.editor&&this.dataset.editorPreview==='true')this.open();},{signal});
   document.addEventListener('shopify:section:select',event=>{if(this.editor&&this.dataset.editorPreview==='true'&&event.detail?.sectionId===this.id.replace('VeiraFormsPopup-',''))this.open();},{signal});
  }
  disconnectedCallback(){this.photoResize?.disconnect();this.formStyleObserver?.disconnect();this.formShadowObserver?.disconnect();clearTimeout(this.formStyleTimer);clearTimeout(this.timer);clearTimeout(this.loadTimer);if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.resize?.disconnect();this.mutation?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veira-kazi-kazan"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('veira-scratch-popup-v1')){
 customElements.define('veira-scratch-popup-v1',class extends HTMLElement{
  connectedCallback(){
   this.formStyleObserver?.disconnect();this.formShadowObserver?.disconnect();clearTimeout(this.formStyleTimer);this.controller?.abort();clearTimeout(this.timer);clearTimeout(this.loadTimer);this.resize?.disconnect();this.mutation?.disconnect();
   this.controller=new AbortController();const signal=this.controller.signal;
   this.dialog=this.querySelector('dialog');this.setupScratch(signal);this.previousFocus=null;this.editor=this.dataset.editor==='true';this.attempts=0;
   this.photoResize?.disconnect();
   const visual=this.querySelector('.vfp-visual');
   this.startProductEntry=()=>{
    const visuals=[...this.querySelectorAll('.vfp-visual')];if(!visuals.length||this.dataset.productAnimation!=='on')return;
    this.productObserver?.disconnect();visuals.forEach(item=>item.removeAttribute('data-products-visible'));
    if(!('IntersectionObserver' in window)){visuals.forEach(item=>item.setAttribute('data-products-visible',''));return;}
    this.productObserver=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting&&this.dialog.open){entry.target.setAttribute('data-products-visible','');this.productObserver.unobserve(entry.target);}}},{root:this.dialog,threshold:.12});
    visuals.forEach(item=>this.productObserver.observe(item));
   };
   if(visual){
    const fitPhoto=()=>{const width=visual.getBoundingClientRect().width;const ratio=Number(this.dataset.imageRatio)||1;if(width>0)this.style.setProperty('--vfp-photo-height',Math.min(width/ratio,Math.max(1,window.innerHeight-48))+'px');};
    this.photoResize=new ResizeObserver(fitPhoto);this.photoResize.observe(visual);fitPhoto();
   }
   const media=matchMedia('(max-width:749px)');
   const allowed=()=>{const device=this.dataset.devices||'all';const page=this.dataset.pages||'all';return(device==='all'||device==='mobile'&&media.matches||device==='desktop'&&!media.matches)&&(page==='all'||page===this.dataset.pageType);};
   const availability=()=>{this.dataset.deviceHidden=String(!allowed());if(!allowed()&&this.dialog.open&&!this.editor)this.close();this.syncTeaser?.();};availability();media.addEventListener('change',availability,{signal});
   const remember=()=>{if(this.editor)return;const key=this.dataset.storageKey;try{if(this.dataset.frequency==='session')sessionStorage.setItem(key,'1');else if(this.dataset.frequency==='days')localStorage.setItem(key,String(Date.now()));}catch{}};
   const seen=()=>{try{if(this.dataset.frequency==='session')return sessionStorage.getItem(this.dataset.storageKey)==='1';if(this.dataset.frequency==='days'){const time=Number(localStorage.getItem(this.dataset.storageKey));return time>0&&Date.now()-time<Number(this.dataset.days)*86400000;}}catch{}return false;};
   this.syncTeaser=()=>{
    const teaser=this.querySelector('[data-vfp-open]');if(!teaser)return;
    const usable=this.editor||(this.dataset.enabled==='true'&&this.dataset.configured==='true'&&allowed());
    const waitingForAuto=this.dataset.auto==='true'&&!seen()&&!this.hasOpened;
    teaser.hidden=!usable||(!this.editor&&waitingForAuto);
   };
   this.syncTeaser();

   this.open=()=>{if(!this.editor&&(this.dataset.enabled!=='true'||this.dataset.configured!=='true'||!allowed()))return;if(this.dialog.open)return;this.previousFocus=document.activeElement;this.dialog.dataset.keyboard='false';this.dialog.showModal();requestAnimationFrame(()=>this.fitMobileCopy?.());this.startProductEntry?.();this.hasOpened=true;this.syncTeaser();requestAnimationFrame(()=>this.drawScratch?.());this.dialog.focus({preventScroll:true});this.checkForm?.();clearTimeout(this.loadTimer);if(this.dataset.editorMock!=='true')this.loadTimer=setTimeout(()=>{if(this.dataset.scratchStage!=='form')return;const mount=this.querySelector('.vfp-form-mount');if(!mount||mount.dataset.vfpState==='ready')return;const loading=this.querySelector('.vfp-loading');if(loading){loading.textContent=this.editor?'Form bağlanamadı. Satır içi form kimliğini ve Forms uygulama yerleştirmesini kontrol edin.':'Form şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.';}const help=this.querySelector('.vfp-connect-help');if(help)help.hidden=false;},12000);remember();};
   this.close=()=>{clearTimeout(this.loadTimer);if(!this.dialog.open)return;this.dialog.close();this.productObserver?.disconnect();this.querySelectorAll('.vfp-visual').forEach(item=>item.removeAttribute('data-products-visible'));if(this.previousFocus?.isConnected)this.previousFocus.focus({preventScroll:true});};
   this.addEventListener('click',event=>{if(event.target.closest('[data-vfp-open]'))this.open();if(event.target.closest('[data-vfp-close]'))this.close();},{signal});
   this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();},{signal});
   this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal});
   this.dialog.addEventListener('pointerdown',()=>this.dialog.dataset.keyboard='false',{capture:true,signal});
   this.dialog.addEventListener('keydown',event=>{if(event.key==='Tab')this.dialog.dataset.keyboard='true';},{signal});

   // Style the existing official fields without cloning, replacing or intercepting submission.
   const styleTemplate=this.querySelector('[data-vfp-form-style]');
   const syncFormSuccess=root=>{
    if(this.dataset.scratchStage!=='form')return;
    // Observe the official success view; a submit click alone never means success.
    const visible=element=>element&&element.getClientRects().length>0&&!element.closest('[hidden]');
    if([...root.querySelectorAll('input[type="email"],button[data-testid="btn-form-submit"]')].some(visible))return;
    const explicit=[...root.querySelectorAll('[data-testid="success-message"],[data-testid="form-success"],[class*="successMessage"],[class*="successContainer"]')].some(visible);
    const normalize=text=>text.normalize('NFKC').toLocaleLowerCase('tr-TR').replace(/\s+/g,' ').trim();
    const coupon=[...root.querySelectorAll('h1,h2,h3,h4,p,span,div,strong,b')].some(element=>{
     if(!visible(element))return false;
     const text=normalize(element.textContent);
     return /^indiriminiz\s*:$/.test(text)||/^indirim kodunuz\s*:$/.test(text);
    });
    if(!explicit&&!coupon)return;
    this.dataset.scratchStage='success';clearTimeout(this.loadTimer);
    this.fitMobileCopy?.();
   };
   const styleForm=()=>{
    for(const embed of this.querySelectorAll('.vfp-form-mount shopify-forms-embed')){
     const root=embed.shadowRoot;if(!root||!styleTemplate)continue;
     if(!root.querySelector('style[data-veira-form-style]'))root.append(styleTemplate.content.cloneNode(true));
     syncFormSuccess(root);
     if(this.styledFormRoot!==root){
      this.formShadowObserver?.disconnect();this.styledFormRoot=root;
      this.formShadowObserver=new MutationObserver(()=>{if(!root.querySelector('style[data-veira-form-style]'))styleForm();syncFormSuccess(root);});
      this.formShadowObserver.observe(root,{childList:true,subtree:true,characterData:true});
     }
    }
   };
   const formMount=this.querySelector('.vfp-form-mount');
   if(formMount){this.formStyleObserver=new MutationObserver(styleForm);this.formStyleObserver.observe(formMount,{childList:true,subtree:true});}
   let styleAttempts=0;
   const waitForForm=()=>{if(!this.isConnected)return;styleForm();if(!this.styledFormRoot&&styleAttempts++<120)this.formStyleTimer=setTimeout(waitForForm,500);};
   if(formMount)waitForForm();

   const mount=this.querySelector('.vfp-form-mount'),loading=this.querySelector('.vfp-loading');
   if(mount&&loading){const check=()=>{if(mount.getBoundingClientRect().height>40){loading.hidden=true;mount.dataset.vfpState='ready';clearTimeout(this.loadTimer);const help=this.querySelector('.vfp-connect-help');if(help)help.hidden=true;}};this.checkForm=check;this.resize=new ResizeObserver(check);this.resize.observe(mount);this.mutation=new MutationObserver(check);this.mutation.observe(mount,{childList:true,subtree:true});check();}
   window.addEventListener('storage',()=>this.syncTeaser(),{signal});
   const auto=()=>{this.syncTeaser();if(!this.isConnected||this.dialog.open||seen()||!allowed()||document.hidden)return;if(document.querySelector('dialog[open]')){if(this.attempts++<10)this.timer=setTimeout(auto,3000);return;}this.open();};
   if(!this.editor&&this.dataset.enabled==='true'&&this.dataset.configured==='true'&&this.dataset.auto==='true')this.timer=setTimeout(auto,Number(this.dataset.delay)*1000);
   if(this.editor&&this.dataset.editorPreview==='true')this.open();
   this.addEventListener('shopify:block:select',()=>{if(this.editor&&this.dataset.editorPreview==='true')this.open();},{signal});
   document.addEventListener('shopify:section:select',event=>{if(this.editor&&this.dataset.editorPreview==='true'&&event.detail?.sectionId===this.id.replace('VeiraScratchPopup-',''))this.open();},{signal});
  }

  fitMobileCopy(){
   const mobile=matchMedia('(max-width:749px)').matches;
   for(const element of this.querySelectorAll('.vfp-content > h2,.vfp-content > .vfp-description')){
    element.style.removeProperty('font-size');
    if(!mobile||!this.dialog.open||element.clientWidth<1)continue;
    const base=parseFloat(getComputedStyle(element).fontSize)||16;
    const width=element.clientWidth;
    if(element.scrollWidth>width){
     let low=1,high=base;
     for(let i=0;i<12;i++){
      const size=(low+high)/2;element.style.fontSize=size+'px';
      if(element.scrollWidth>width)high=size;else low=size;
     }
     element.style.fontSize=Math.floor(low*100)/100+'px';
    }
   }
  }
  setupScratch(signal){
   const canvas=this.querySelector('.vfp-scratch-canvas');
   const intro=this.querySelector('.vfp-scratch-intro');
   const formStep=this.querySelector('.vfp-scratch-form-step');
   if(!canvas||!intro||!formStep)return;
   this.copyResize?.disconnect();const content=this.querySelector('.vfp-content');
   if(content){this.copyResize=new ResizeObserver(()=>this.fitMobileCopy());this.copyResize.observe(content);}
   window.addEventListener('resize',()=>this.fitMobileCopy(),{passive:true,signal});
   const ctx=canvas.getContext('2d',{willReadFrequently:true});
   const claim=this.querySelector('.vfp-scratch-claim');
   const revealButton=this.querySelector('.vfp-scratch-reveal');
   const status=this.querySelector('.vfp-scratch-announcement');
   const card=this.querySelector('.vfp-scratch-card');
   this.dataset.scratchStage='scratch';
   this.scratchStrokes=[];this.scratchDone=false;this.scratchPointer=null;
   const reveal=()=>{
    if(this.scratchDone)return;
    const moving=[...this.querySelectorAll('.vfp-logo,.vfp-content > h2,.vfp-content > .vfp-description,.vfp-scratch-prize,.vfp-footnote')];
    const before=new Map(moving.map(element=>[element,element.getBoundingClientRect()]));
    this.scratchDone=true;this.dataset.scratchStage='revealed';card.dataset.revealed='true';
    const hint=this.querySelector('.vfp-scratch-status');if(hint)hint.hidden=true;
    this.fitMobileCopy?.();
    card.querySelector('.vfp-scratch-prize').removeAttribute('aria-hidden');
    claim.hidden=false;revealButton.hidden=true;
    status.textContent='İndirimin hazır. Alttaki düğmeden devam edebilirsin.';
    // Animate the reflow positions without scaling text or moving the bottom photo.
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches&&typeof card.animate==='function'){
     const animations=[];
     for(const element of moving){
      const first=before.get(element),last=element.getBoundingClientRect();
      if(!first.width||!last.width)continue;
      const dx=first.left-last.left,dy=first.top-last.top;
      if(Math.abs(dx)+Math.abs(dy)<1)continue;
      animations.push(element.animate([
       {transform:`translate(${dx}px,${dy}px)`},
       {transform:'translate(0,0)'}
      ],{duration:560,easing:'cubic-bezier(.22,1,.36,1)'}));
     }
     animations.push(claim.animate([
      {opacity:0,transform:'translateY(12px)'},
      {opacity:1,transform:'translateY(0)'}
     ],{duration:400,delay:100,fill:'backwards',easing:'cubic-bezier(.22,1,.36,1)'}));
     const cancel=()=>animations.forEach(animation=>animation.cancel());
     signal.addEventListener('abort',cancel,{once:true});
     Promise.allSettled(animations.map(animation=>animation.finished)).then(()=>signal.removeEventListener('abort',cancel));
    }

   };
   const erase=stroke=>{
    if(!ctx)return;
    const width=this.scratchWidth,height=this.scratchHeight;
    ctx.globalCompositeOperation='destination-out';ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=Math.max(28,width*.115);
    ctx.beginPath();ctx.moveTo(stroke[0]*width,stroke[1]*height);ctx.lineTo(stroke[2]*width,stroke[3]*height);ctx.stroke();
    ctx.beginPath();ctx.arc(stroke[2]*width,stroke[3]*height,ctx.lineWidth/2,0,Math.PI*2);ctx.fill();
   };
   const fitReward=()=>{
    const text=card.querySelector('.vfp-scratch-prize strong');
    if(!text||!ctx||this.dataset.autoRewardSize==='false')return;
    const width=card.getBoundingClientRect().width-40;if(width<1)return;
    ctx.save();const font=getComputedStyle(text);ctx.font=`850 100px ${font.fontFamily}`;
    const measured=ctx.measureText(text.textContent.trim()).width;ctx.restore();
    if(measured>0)text.style.fontSize=Math.min(72,width/measured*100)+'px';
   };
   this.drawScratch=()=>{
    fitReward();
    if(this.scratchDone||!ctx||!this.dialog.open)return;
    const r=card.getBoundingClientRect();if(r.width<1||r.height<1)return;
    const dpr=Math.min(window.devicePixelRatio||1,2);
    if(this.scratchWidth===r.width&&this.scratchHeight===r.height)return;
    this.scratchWidth=r.width;this.scratchHeight=r.height;
    canvas.width=Math.round(r.width*dpr);canvas.height=Math.round(r.height*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);ctx.globalCompositeOperation='source-over';
    const gradient=ctx.createLinearGradient(0,0,r.width,r.height);gradient.addColorStop(0,'#bf943d');gradient.addColorStop(.35,'#f0d88e');gradient.addColorStop(.65,'#c5a052');gradient.addColorStop(1,'#ead79a');ctx.fillStyle=gradient;ctx.fillRect(0,0,r.width,r.height);
    for(let i=0;i<1600;i++){ctx.fillStyle=i%2?'rgba(255,255,255,.12)':'rgba(86,59,14,.08)';ctx.fillRect(Math.random()*r.width,Math.random()*r.height,1,1);}
    // Fine grain and diagonal engraved marks, drawn without image downloads.
    ctx.save();ctx.globalAlpha=.09;ctx.strokeStyle='#77551b';ctx.lineWidth=r.width*.045;ctx.lineCap='round';
    for(let i=0;i<5;i++){const x=r.width*(.31+i*.075);ctx.beginPath();ctx.moveTo(x,r.height*.32);ctx.lineTo(x-r.width*.12,r.height*.68);ctx.stroke();}
    ctx.restore();
    ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillStyle='rgba(255,255,255,.9)';
    const label=this.dataset.scratchLabel||'BURAYI KAZI';let fontSize=Math.min(36,r.width*.1);ctx.font=`800 ${fontSize}px -apple-system,BlinkMacSystemFont,Arial,sans-serif`;
    if(ctx.measureText(label).width>r.width*.86){fontSize*=r.width*.86/ctx.measureText(label).width;ctx.font=`800 ${fontSize}px -apple-system,BlinkMacSystemFont,Arial,sans-serif`;}
    ctx.fillText(label,r.width/2,r.height/2);
    canvas.style.background='transparent';
    this.scratchStrokes.forEach(erase);
   };
   const point=e=>{const r=canvas.getBoundingClientRect();return[(e.clientX-r.left)/r.width,(e.clientY-r.top)/r.height];};
   const check=()=>{
    if(!ctx||this.scratchDone)return;
    const data=ctx.getImageData(0,0,canvas.width,canvas.height).data;let cleared=0,total=0;
    for(let i=3;i<data.length;i+=64){total++;if(data[i]<80)cleared++;}
    if(total&&cleared/total>=.35)reveal();
   };
   canvas.addEventListener('pointerdown',e=>{if(this.scratchDone||!ctx||!e.isPrimary||(e.pointerType==='mouse'&&e.button!==0))return;e.preventDefault();this.scratchPointer=e.pointerId;this.scratchLast=point(e);canvas.setPointerCapture(e.pointerId);const p=this.scratchLast,stroke=[...p,...p];this.scratchStrokes.push(stroke);erase(stroke);},{signal});
   canvas.addEventListener('pointermove',e=>{if(this.scratchPointer!==e.pointerId||this.scratchDone)return;e.preventDefault();const p=point(e),stroke=[...this.scratchLast,...p];this.scratchStrokes.push(stroke);erase(stroke);this.scratchLast=p;const now=performance.now();if(now-(this.scratchCheckTime||0)>180){this.scratchCheckTime=now;check();}},{signal});
   const end=e=>{if(this.scratchPointer===e.pointerId){this.scratchPointer=null;check();}};
   canvas.addEventListener('pointerup',end,{signal});canvas.addEventListener('pointercancel',end,{signal});canvas.addEventListener('lostpointercapture',end,{signal});
   revealButton.addEventListener('click',reveal,{signal});
   card.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();reveal();}},{signal});
   claim.addEventListener('click',()=>{
    if(!this.scratchDone)return;
    intro.hidden=true;formStep.hidden=false;this.dataset.scratchStage='form';this.fitMobileCopy?.();
    this.checkForm?.();const mock=formStep.querySelector('.vfp-design-form');
    const mount=formStep.querySelector('.vfp-form-mount');
    (mock||mount||formStep).setAttribute('tabindex','-1');(mock||mount||formStep).focus({preventScroll:true});
    clearTimeout(this.loadTimer);this.loadTimer=setTimeout(()=>{this.checkForm?.();const loading=this.querySelector('.vfp-loading');if(mount&&mount.dataset.vfpState!=='ready'&&loading){loading.textContent='Form şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.';}},12000);
   },{signal});
   if(!ctx){revealButton.hidden=false;status.textContent='Sürprizini görmek için “Kazımadan göster” düğmesine dokun.';}
   this.scratchResize?.disconnect();this.scratchResize=new ResizeObserver(()=>{fitReward();this.drawScratch?.();});this.scratchResize.observe(card);
  }

  disconnectedCallback(){this.copyResize?.disconnect();this.productObserver?.disconnect();this.scratchResize?.disconnect();this.photoResize?.disconnect();this.formStyleObserver?.disconnect();this.formShadowObserver?.disconnect();clearTimeout(this.formStyleTimer);clearTimeout(this.timer);clearTimeout(this.loadTimer);if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.resize?.disconnect();this.mutation?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veira-koleksiyon-vitrini"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('veira-collection-experience')){
 customElements.define('veira-collection-experience',class extends HTMLElement{
  connectedCallback(){
   this.cleanup?.();const controller=new AbortController(),signal=controller.signal;
   const reduced=matchMedia('(prefers-reduced-motion:reduce)'),pointer=matchMedia('(hover:hover) and (pointer:fine)');
   let frame=0,active=null,pending=null;const scenes=[...this.querySelectorAll('[data-vce-scene]')];
   const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
     if(entry.target.hasAttribute('data-vce-scene'))entry.target.dataset.visible=String(entry.isIntersecting&&!document.hidden);
     else if(entry.isIntersecting){if(!reduced.matches)entry.target.classList.add('vce-reveal');observer.unobserve(entry.target);}
    }
   },{threshold:.08});
   scenes.forEach(scene=>observer.observe(scene));
   if(this.dataset.effects==='true')this.querySelectorAll('[data-vce-card],.vce-story').forEach(card=>observer.observe(card));
   const reset=()=>{cancelAnimationFrame(frame);if(active){active.style.removeProperty('--vce-rx');active.style.removeProperty('--vce-ry');}active=null;pending=null;};
   this.addEventListener('pointermove',event=>{
    if(this.dataset.effects!=='true'||this.dataset.tilt!=='true'||reduced.matches||!pointer.matches)return;
    const card=event.target.closest('[data-vce-card]');if(!card)return;
    if(active!==card){reset();active=card;}
    pending={x:event.clientX,y:event.clientY};if(frame)return;
    frame=requestAnimationFrame(()=>{frame=0;if(!active||!pending)return;const r=active.getBoundingClientRect();active.style.setProperty('--vce-rx',((.5-(pending.y-r.top)/r.height)*5).toFixed(2)+'deg');active.style.setProperty('--vce-ry',(((pending.x-r.left)/r.width-.5)*5).toFixed(2)+'deg');});
   },{passive:true,signal});
   this.addEventListener('pointerout',event=>{if(active&&!active.contains(event.relatedTarget))reset();},{signal});
   const button=this.querySelector('[data-vce-pause]');
   button?.addEventListener('click',()=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Animasyonları oynat':'Animasyonları duraklat');button.querySelector('[data-vce-pause-icon]').textContent=paused?'▷':'Ⅱ';},{signal});
   document.addEventListener('visibilitychange',()=>{if(document.hidden){scenes.forEach(scene=>scene.dataset.visible='false');reset();}else scenes.forEach(scene=>{observer.unobserve(scene);observer.observe(scene);});},{signal});
   const motionChange=()=>{reset();if(reduced.matches)this.querySelectorAll('.vce-reveal').forEach(el=>el.classList.remove('vce-reveal'));};
   reduced.addEventListener('change',motionChange,{signal});pointer.addEventListener('change',reset,{signal});
   document.addEventListener('shopify:block:select',event=>{if(!this.contains(event.target))return;event.target.scrollIntoView({behavior:'auto',block:'center'});},{signal});
   this.cleanup=()=>{controller.abort();observer.disconnect();reset();};
  }
  disconnectedCallback(){this.cleanup?.();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veira-partner-collabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('veira-partner-portal-v10')){
 customElements.define('veira-partner-portal-v10',class extends HTMLElement{
  connectedCallback(){
   const start=()=>{if(!this.querySelector('[data-vpp-source]'))return;this.observer?.disconnect();this.controller?.abort();this.controller=new AbortController();this.init();};
   this.observer=new MutationObserver(start);this.observer.observe(this,{childList:true,subtree:true});start();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.querySelector('[data-date-dialog]')?.close();delete this.dataset.initialized;}
  init(){const root=this;if(root.dataset.initialized==='true')return;
              const source = root.querySelector('[data-vpp-source]');
              const panel = root.querySelector('[data-filter-panel]');
              if (!source || !panel) return;

              let report;
              try {
                report = JSON.parse(source.dataset.report);
              } catch (_) {
                return;
              }

              let ui={};try{ui=JSON.parse(root.dataset.ui||'{}');}catch(_){}
              const text=(key,fallback)=>typeof ui[key]==='string'&&ui[key].trim()?ui[key]:fallback;
              const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:root.controller.signal});
              on(root,'pointerdown',()=>root.dataset.keyboard='false');
              on(root,'keydown',event=>{if(event.key==='Tab')root.dataset.keyboard='true';});
              const setMode=mode=>{
                root.dataset.filterMode=mode;
                const choice=panel.querySelector('[data-period]');
                root.querySelector('[data-summary-title]').textContent=mode==='range'?(choice.options[choice.selectedIndex]?.text||'Özel aralık'):'Tüm Zamanlar Özeti';
              };
              const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
              const validDate = value =>
                typeof value === 'string' && isoPattern.test(value) && (()=>{
                  const [y,m,d]=value.split('-').map(Number);const date=new Date(Date.UTC(y,m-1,d));
                  return date.getUTCFullYear()===y&&date.getUTCMonth()===m-1&&date.getUTCDate()===d;
                })();
              const validNumber = value =>
                typeof value === 'number' && Number.isFinite(value);

              const todayParts=new Intl.DateTimeFormat('en-CA',{timeZone:report.timezone||'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
              const today=['year','month','day'].map(key=>todayParts.find(part=>part.type===key).value).join('-');
              const numeric=value=>typeof value==='number'?value:typeof value==='string'&&/^[+-]?\d+(?:\.\d+)?$/.test(value.trim())?Number(value):NaN;
              if(Array.isArray(report.daily))report.daily=report.daily.map(item=>item&&({...item,orders:numeric(item.orders),sales:numeric(item.sales),earned:numeric(item.earned)}));
              if(report.payouts==null)report.payouts=[];
              if(Array.isArray(report.payouts))report.payouts=report.payouts.map(item=>item&&({...item,amount:numeric(item.amount)}));
              report.rate=numeric(report.rate);
              if(!validDate(report.dailyFrom))report.dailyFrom=validDate(report.dataFrom)?report.dataFrom:Array.isArray(report.daily)&&report.daily.length?report.daily.filter(item=>item&&validDate(item.date)).map(item=>item.date).sort()[0]:today;
              if(!validDate(report.dailyUntil))report.dailyUntil=today;
              if (
                !Array.isArray(report.daily) ||
                !Array.isArray(report.payouts) ||
                !validDate(report.dailyFrom) ||
                !validDate(report.dailyUntil) ||
                report.dailyFrom > report.dailyUntil
              ) return;

              const validDaily = report.daily.every(item =>
                item &&
                validDate(item.date) &&
                validNumber(item.orders) &&
                validNumber(item.sales) &&
                (validNumber(item.earned)||(validNumber(report.rate)&&report.rate>=0&&report.rate<=100))
              );
              const validPayouts = report.payouts.every(item =>
                item &&
                validDate(item.date) &&
                validNumber(item.amount)
              );
              if (!validDaily || !validPayouts) return;

              let money;
              try {
                money = new Intl.NumberFormat('tr-TR', {
                  style: 'currency',
                  currency: report.currency || 'TRY'
                });
              } catch (_) {
                return;
              }

              root.dataset.initialized = 'true';
              source.hidden=true;

              const number = new Intl.NumberFormat('tr-TR');
              const form = panel.querySelector('[data-filter-form]');
              const period=panel.querySelector('[data-period]');
              let applyingPreset=false;
              const start = form.elements.start;
              const end = form.elements.end;
              const status = panel.querySelector('[data-status]');
              const coverage = panel.querySelector('[data-coverage]');
              const paymentBox = root.querySelector('[data-payments]');
              const keys = ['orders', 'sales', 'earned', 'paid'];
              const values = {};
              const labels = {};
              const originalValues = {};
              const originalLabels = {};

              keys.forEach(key => {
                values[key] = root.querySelector(
                  '[data-value="' + key + '"]'
                );
                labels[key] = root.querySelector(
                  '[data-label="' + key + '"]'
                );
                originalValues[key] = root.originalTotals?.values[key] ?? values[key].textContent;
                originalLabels[key] = root.originalTotals?.labels[key] ?? labels[key].textContent;
              });

              root.originalTotals={values:originalValues,labels:originalLabels};
              const dateText = date =>
                date.split('-').reverse().join('.');

              const cents = value => Math.round(value * 100);

              const asDate=value=>{const [year,month,day]=value.split('-').map(Number);return new Date(Date.UTC(year,month-1,day));};
              const asISO=date=>date.toISOString().slice(0,10);
              const plusDays=(value,days)=>{const date=asDate(value);date.setUTCDate(date.getUTCDate()+days);return asISO(date);};
              function presetRange(key){
                const date=asDate(today),year=date.getUTCFullYear(),month=date.getUTCMonth();
                if(key==='today')return [today,today];
                if(key==='last7')return [plusDays(today,-6),today];
                if(key==='last30')return [plusDays(today,-29),today];
                if(key==='last90')return [plusDays(today,-89),today];
                if(key==='this_month')return [asISO(new Date(Date.UTC(year,month,1))),today];
                if(key==='last_month')return [asISO(new Date(Date.UTC(year,month-1,1))),asISO(new Date(Date.UTC(year,month,0)))];
                if(key==='this_year')return [year+'-01-01',today];
                return null;
              }
              const lowerBound=validDate(report.dataFrom)&&report.dataFrom<report.dailyFrom?report.dataFrom:report.dailyFrom;
              const upperBound=today>report.dailyUntil?today:report.dailyUntil;
              const within = (date, from, until) =>
                (!from || date >= from) &&
                (!until || date <= until);

              [start, end].forEach(input => {
                input.min = lowerBound;
                input.max = upperBound;
              });

              start.value = '';
              end.value = '';

              if(coverage)coverage.textContent =
                'Seçilebilir günlük veri: ' +
                dateText(report.dailyFrom) + ' – ' +
                dateText(report.dailyUntil) +
                '. Saat dilimi: ' +
                (report.timezone || 'Europe/Istanbul') +
                '. İadeler gerçekleştiği günün satışından düşülür.';

              if (
                coverage && validDate(report.dataFrom) &&
                report.dailyFrom > report.dataFrom
              ) {
                coverage.textContent +=
                  ' Eski günlük kayıtlar aktarım sınırı nedeniyle ' +
                  'bu aralıkta yoktur. Tüm zamanlar kartları ' +
                  'genel toplamları göstermeye devam eder.';
              }

              function showPayments(from, until) {
                if(!paymentBox)return;
                paymentBox.replaceChildren();

                const selected = report.payouts
                  .filter(item => within(item.date, from, until))
                  .slice()
                  .sort((a, b) => b.date.localeCompare(a.date));

                if (!selected.length) {
                  const empty = document.createElement('p');
                  empty.className = 'vpp__status';
                  empty.textContent = from
                    ? 'Seçili tarih aralığında kayıtlı ödeme yok.'
                    : 'Kayıtlı ödeme yok.';
                  paymentBox.append(empty);
                  return;
                }

                const list = document.createElement('ul');
                list.className = 'vpp__payment-list';

                selected.forEach(item => {
                  const row = document.createElement('li');
                  row.className = 'vpp__payment';

                  const date = document.createElement('div');
                  date.className='vpp__payment-details';
                  const dateLabel=document.createElement('span');dateLabel.textContent=typeof item.dateText==='string'&&item.dateText.trim()?item.dateText:dateText(item.date);date.append(dateLabel);

                  const amount = document.createElement('strong');
                  amount.textContent = typeof item.amountText==='string'&&item.amountText.trim()?item.amountText:money.format(item.amount);

                  if(typeof item.note==='string'&&item.note.trim()){
                    const note=document.createElement('p');note.className='vpp__payment-note';note.textContent=item.note;date.append(note);
                  }
                  row.append(date, amount);
                  list.append(row);
                });

                paymentBox.append(list);
              }

              const details=panel.querySelector('[data-filter-details]');
              const activeRange=panel.querySelector('[data-active-range]');
              const updateDateButtons=()=>{for(const key of ['start','end']){const input=key==='start'?start:end;panel.querySelector('[data-date-value="'+key+'"]').textContent=input.value?dateText(input.value):'Tarih seç';panel.querySelector('[data-date-picker="'+key+'"]').toggleAttribute('data-filled',!!input.value);}};
              function resetAll(){
                keys.forEach(key=>{values[key].textContent=originalValues[key];labels[key].textContent=originalLabels[key];});
                start.value='';end.value='';period.value='all';
                start.removeAttribute('aria-invalid');end.removeAttribute('aria-invalid');
                updateDateButtons();activeRange.textContent=text('reset_text','Tüm zamanlar');
                setMode('all');
                status.textContent=text('all_status','Tüm zamanlar gösteriliyor.');
                showPayments('','');
              }
              const fieldError=message=>{status.textContent=message;start.setAttribute('aria-invalid','true');end.setAttribute('aria-invalid','true');};
              on(form,'input',()=>{start.removeAttribute('aria-invalid');end.removeAttribute('aria-invalid');});

              on(form,'submit', event => {
                event.preventDefault();
                start.removeAttribute('aria-invalid');end.removeAttribute('aria-invalid');

                const from = start.value;
                const until = end.value;
                if(!from&&!until){resetAll();return;}
                if(!from||!until){fieldError('Başlangıç ve bitiş tarihlerini birlikte seçin.');return;}

                if (
                  !validDate(from) ||
                  !validDate(until) ||
                  from > until ||
                  (!applyingPreset && from < lowerBound) ||
                  until > upperBound
                ) {
                  fieldError('Veri kapsamı içinde geçerli bir tarih aralığı seçin. Başlangıç tarihi bitişten sonra olamaz.');
                  return;
                }

                let orders = 0;
                let salesCents = 0;
                let paidCents = 0;
                let earnedCents = 0;let rateSalesCents=0;

                report.daily.forEach(item => {
                  if (within(item.date, from, until)) {
                    orders += item.orders;
                    salesCents += cents(item.sales);
                    if(validNumber(item.earned))earnedCents+=cents(item.earned);else rateSalesCents+=cents(item.sales);
                  }
                });

                report.payouts.forEach(item => {
                  if (within(item.date, from, until)) {
                    paidCents += cents(item.amount);
                  }
                });

                if(rateSalesCents)earnedCents+=Math.round(rateSalesCents*report.rate/100);

                labels.orders.textContent = text('period_orders','Dönem Siparişleri');
                labels.sales.textContent = text('period_sales','Dönem Satışı');
                labels.earned.textContent =
                  text('period_earned','Dönemde Kazanılan Komisyon');
                labels.paid.textContent = text('period_paid','Dönemde Yapılan Ödemeler');

                values.orders.textContent = number.format(orders);
                values.sales.textContent =
                  money.format(salesCents / 100);
                values.earned.textContent =
                  money.format(earnedCents / 100);
                values.paid.textContent =
                  money.format(paidCents / 100);

                status.textContent =
                  dateText(from) + ' – ' + dateText(until) +
                  ' gösteriliyor. Başlangıç ve bitiş günleri dahil.'+((from<report.dailyFrom||until>report.dailyUntil)?' Bu aralığın tamamı günlük raporda yer almıyor; yalnızca mevcut kayıtlar hesaplandı.':'');

                if(!applyingPreset)period.value='custom';
                activeRange.textContent=(period.value!=='custom'?period.options[period.selectedIndex].text+' · ':'')+dateText(from)+' – '+dateText(until);
                updateDateButtons();details.open=true;
                setMode('range');
                showPayments(from, until);
              });

              on(period,'change',()=>{
                if(period.value==='all'){resetAll();return;}
                if(period.value==='custom'){details.open=true;return;}
                const range=presetRange(period.value);if(!range)return;
                start.value=range[0];end.value=range[1];updateDateButtons();
                applyingPreset=true;try{form.requestSubmit();}finally{applyingPreset=false;}
              });

              const dialog=root.querySelector('[data-date-dialog]');
              const manual=dialog.querySelector('[data-date-manual]');
              const calendar=dialog.querySelector('[data-calendar]');
              const error=dialog.querySelector('[data-date-error]');
              const monthTitle=dialog.querySelector('[data-month-title]');
              const prev=dialog.querySelector('[data-month-prev]'),next=dialog.querySelector('[data-month-next]');
              let choosing='start',draft='',month='',returnFocus=null;
              const isoDay=(y,m,d)=>String(y).padStart(4,'0')+'-'+String(m+1).padStart(2,'0')+'-'+String(d).padStart(2,'0');
              const monthShift=(key,offset)=>{const [y,m]=key.split('-').map(Number);const date=new Date(Date.UTC(y,m-1+offset,1));return isoDay(date.getUTCFullYear(),date.getUTCMonth(),1).slice(0,7);};
              const inCoverage=value=>validDate(value)&&value>=lowerBound&&value<=upperBound;
              const parseManual=()=>{const match=manual.value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);return match?match[3]+'-'+match[2]+'-'+match[1]:'';};
              function drawMonth(){
                const [year,mon]=month.split('-').map(Number);
                monthTitle.textContent=new Intl.DateTimeFormat('tr-TR',{month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(Date.UTC(year,mon-1,1)));
                prev.disabled=month<=lowerBound.slice(0,7);next.disabled=month>=upperBound.slice(0,7);
                calendar.replaceChildren();
                const offset=(new Date(Date.UTC(year,mon-1,1)).getUTCDay()+6)%7;
                for(let i=0;i<offset;i++){const blank=document.createElement('span');blank.setAttribute('aria-hidden','true');calendar.append(blank);}
                const days=new Date(Date.UTC(year,mon,0)).getUTCDate();
                for(let day=1;day<=days;day++){
                  const value=isoDay(year,mon-1,day),button=document.createElement('button');button.type='button';button.dataset.day=value;button.textContent=String(day);
                  button.disabled=!inCoverage(value);button.setAttribute('aria-label',dateText(value));button.setAttribute('aria-pressed',String(value===draft));calendar.append(button);
                }
              }
              const closePicker=()=>{if(dialog.open)dialog.close();returnFocus?.focus({preventScroll:true});};
              on(panel,'click',event=>{const trigger=event.target.closest('[data-date-picker]');if(!trigger)return;choosing=trigger.dataset.datePicker;returnFocus=trigger;draft=(choosing==='start'?start:end).value;month=(draft||(choosing==='start'?lowerBound:upperBound)).slice(0,7);manual.value=draft?dateText(draft):'';error.textContent='';dialog.querySelector('[data-date-title]').textContent=choosing==='start'?text('start_label','Başlangıç'):text('end_label','Bitiş');drawMonth();if(!dialog.open)dialog.showModal();dialog.focus({preventScroll:true});});
              on(prev,'click',()=>{month=monthShift(month,-1);drawMonth();});on(next,'click',()=>{month=monthShift(month,1);drawMonth();});
              on(calendar,'click',event=>{const button=event.target.closest('button[data-day]');if(!button||button.disabled)return;draft=button.dataset.day;manual.value=dateText(draft);error.textContent='';drawMonth();});
              on(manual,'input',()=>{error.textContent='';const value=parseManual();if(inCoverage(value)){draft=value;month=value.slice(0,7);drawMonth();}});
              function confirmDate(){
                const value=parseManual();if(!inCoverage(value)){error.textContent='GG.AA.YYYY biçiminde '+dateText(lowerBound)+' – '+dateText(upperBound)+' arasında bir tarih girin.';manual.setAttribute('aria-invalid','true');return;}
                manual.removeAttribute('aria-invalid');period.value='custom';(choosing==='start'?start:end).value=value;start.removeAttribute('aria-invalid');end.removeAttribute('aria-invalid');updateDateButtons();closePicker();if(start.value&&end.value)form.requestSubmit();
              }
              on(dialog.querySelector('[data-date-confirm]'),'click',confirmDate);
              on(manual,'keydown',event=>{if(event.key==='Enter'){event.preventDefault();confirmDate();}});
              on(dialog.querySelector('[data-date-close]'),'click',closePicker);
              on(dialog,'cancel',event=>{event.preventDefault();closePicker();});
              on(dialog,'click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closePicker();});

              resetAll();
              panel.hidden = false;

  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
